import {
  exists,
  defaultSystemCode,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

import { dateTimeToDateFormat, dateTimeToPlainFormat } from '@/utils'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ReserveCollection {
  id: number
  collectionId: number
  collectionNo: string
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayClass: string
  displayTitle: string
  displayAuthor: string
  reserveRegistrationTime: string
  collectionUpdatedTime: string
  collectionStatus: SystemCode
  reserveStatus: SystemCode
  reserveStatusMessage: string
  reserveExpiration: string
  reserveRegistrationBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  forwardingPlaceCode: SystemCode
  specifyCollectionId: string
  reserveSetId: number
  reserveSetRank: number
  reserveGroupId: number
  displayMaterialFormat: SystemCode
  reserveContactCompleted: boolean
  displayMemo: string
  collectionFlag: CollectionFlag
  revision: number
  rank: number
}

export function ReserveCollectionFromJSON(json: any): ReserveCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    reserveRegistrationTime: exists(json, 'reserve_registration_time')
      ? dateTimeToPlainFormat(json.reserve_registration_time)
      : '',
    collectionUpdatedTime: exists(json, 'collection_updated_time')
      ? dateTimeToPlainFormat(json.collection_updated_time)
      : '',
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    reserveStatus: exists(json, 'reserve_status')
      ? SystemCodeFromJSON(json.reserve_status)
      : defaultSystemCode(),
    reserveStatusMessage: exists(json, 'reserve_status_message')
      ? json.reserve_status_message
      : '',
    reserveExpiration: exists(json, 'reserve_expiration')
      ? dateTimeToDateFormat(dateTimeToPlainFormat(json.reserve_expiration))
      : '',
    reserveRegistrationBranchCode: exists(
      json,
      'reserve_registration_branch_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    forwardingPlaceCode: exists(json, 'forwarding_place_code')
      ? SystemCodeFromJSON(json.forwarding_place_code)
      : defaultSystemCode(),
    specifyCollectionId: exists(json, 'specify_collection_id')
      ? json.specify_collection_id
      : '',
    reserveSetId: exists(json, 'reserve_set_id') ? json.reserve_set_id : 0,
    reserveSetRank: exists(json, 'reserve_set_rank')
      ? json.reserve_set_rank
      : 0,
    reserveGroupId: exists(json, 'reserve_group_id')
      ? json.reserve_group_id
      : 0,
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    reserveContactCompleted: exists(json, 'reserve_contact_completed')
      ? json.reserve_contact_completed
      : false,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0,
    rank: exists(json, 'rank') ? json.rank : 0
  }
}

export const defaultReserveCollection = (): ReserveCollection => ({
  id: 0,
  collectionId: 0,
  collectionNo: '',
  bibliographyId: 0,
  bibliographyClass: BibliographyClass.Real,
  prefix: Prefix.Real,
  searchType: defaultSystemCode(),
  displayClass: '',
  displayTitle: '',
  displayAuthor: '',
  reserveRegistrationTime: '',
  collectionUpdatedTime: '',
  collectionStatus: defaultSystemCode(),
  reserveStatus: defaultSystemCode(),
  reserveStatusMessage: '',
  reserveExpiration: '',
  reserveRegistrationBranchCode: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  forwardingPlaceCode: defaultSystemCode(),
  specifyCollectionId: '',
  reserveSetId: 0,
  reserveSetRank: 0,
  reserveGroupId: 0,
  displayMaterialFormat: defaultSystemCode(),
  reserveContactCompleted: false,
  displayMemo: '',
  collectionFlag: CollectionFlag.NotCollection,
  revision: 1,
  rank: 0
})
